<mat-form-field appearance="fill">
  <input class="form-control w-100" type="text" matInput #inputField [matAutocomplete]="auto"/>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let value of displayedValues; let i = index" [value]="value" [attr.data-index]="i">
      {{ value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
